import { useState } from "react";
import { toastr } from "react-redux-toastr";
import { Button, Input } from "expano-components";
import useCreate from "hooks/useCreate";
import { Modal, AsyncSelect } from "components";
import getPlatformTaxonOptions from "utils/select_options/getPlatformTaxonOptions";
import { getApiErrorMessage } from "utils/api";

import { ReactComponent as CategoryIcon } from "icons/category.svg";
import getPlatformTaxonByExternalId from "utils/select_options/getPlatformTaxonByExternalId";

const AddPlatformTaxon = ({
  platform_id,
  product_group_id,
  refetch,
  handleClose,
}) => {
  const [platform_taxon_id, setPlatformTaxonId] = useState(null);
  const [platform_taxon_external_id, setPlatformTaxonExternalId] =
    useState(null);
  const [platform_taxon_external, setPlatformTaxonExternal] = useState(null);

  const { is_creating, create } = useCreate({
    path: "/platform_taxon_product_groups",
    success_message: "Kategoria została dodana",
    onSuccess: () => [refetch(), handleClose()],
  });

  const handleSearchByPlatformExternalId = async () => {
    try {
      setPlatformTaxonExternal(null);
      const data = await getPlatformTaxonByExternalId({
        platform_id,
        external_id: platform_taxon_external_id,
      });
      setPlatformTaxonExternal(data);
    } catch (error) {
      toastr.error("Błąd", getApiErrorMessage(error));
    }
  };

  return (
    <Modal
      size="lg"
      handleClose={handleClose}
      header={{
        title: "Dodaj kategorię",
        icon: <CategoryIcon />,
      }}
      footer={
        <>
          <Button type="cancel" onClick={handleClose} />
        </>
      }
    >
      <AsyncSelect
        label="Kategoria"
        onChange={({ value }) => setPlatformTaxonId(value)}
        getData={(q) => getPlatformTaxonOptions(q, platform_id)}
      />
      <Button
        type="add-green"
        disabled={!platform_taxon_id || is_creating}
        text="Dodaj"
        onClick={() => create({ platform_taxon_id, product_group_id })}
      />
      <div className="search-group m-t-20">
        <div className="search-group__search">
          <Input
            label="Szukaj po ID zewnętrznym"
            input={{
              name: "external_id",
              value: platform_taxon_external_id,
              onChange: ({ target: { value } }) =>
                setPlatformTaxonExternalId(value),
            }}
            meta={{}}
          />

          <button
            type="add"
            className="btn btn-sm btn-blue"
            disabled={!platform_taxon_external_id}
            onClick={handleSearchByPlatformExternalId}
          >
            <span>Szukaj</span>
          </button>
        </div>
        {platform_taxon_external?.id && (
          <div className="search-group__result">
            <p className="title">Znaleziona kategoria:</p>
            <p className="result">
              {platform_taxon_external.name} [
              {platform_taxon_external.external_id}]
            </p>
            <Button
              type="add-green"
              disabled={is_creating}
              text="Dodaj"
              onClick={() =>
                create({
                  platform_taxon_id: platform_taxon_external.id,
                  product_group_id,
                })
              }
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default AddPlatformTaxon;
